import { createAction } from '@ngrx/store';

export const showSelectSettlementTimingModal = createAction('[SettlementTiming] Show Select Modal');

export const showSettlementTimingExplainModal = createAction('[SettlementTiming] Show Explain Modal');
